
export const createMockState = (value) => ({
    get: () => value,
    set: (v2) => value = v2,
});
